module.exports = __webpack_public_path__ + "static/media/mickey_mouse.4fc58a8b.jpg";